import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ViewerManagerRuntimeLayoutApi } from './viewerManagerRuntimeLayoutApi'
import { ViewerManagerApiImplementor } from 'thunderbolt-viewer-manager-types'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import { DetachApiSymbol, LayoutRuntimeAPISymbol } from './symbols'
import { DetachApi } from './detachApi'
import { OnLayoutUpdateHandler } from './onLayoutUpdateHandler'
import { LayoutRuntimeAPI } from './layoutRuntime'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ModelUpdatesHandlersImplementor).to(OnLayoutUpdateHandler)
	bind(DetachApiSymbol).to(DetachApi)
	bind(LayoutRuntimeAPISymbol).to(LayoutRuntimeAPI)
	bind(ViewerManagerApiImplementor).to(ViewerManagerRuntimeLayoutApi)
}
